module.exports = __webpack_public_path__ + "img/kitkitphoto13.17aae6cb.jpg";